import { useEffect, useCallback, useRef } from 'react'

interface UseFilterClearProps {
  inputId: string
  filterValue: string
  setFilterValue: (value: string) => void
}

export const useFilterClear = ({ inputId, filterValue, setFilterValue }: UseFilterClearProps) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const containerRef = useRef<Element | null>(null)

  const checkForClear = useCallback(() => {
    const inputElement = document.getElementById(inputId) as HTMLInputElement
    if (inputElement && inputElement.value === '' && filterValue !== '') {
      setFilterValue('')
    }
  }, [inputId, filterValue, setFilterValue])

  const handleClick = useCallback(() => {
    setTimeout(checkForClear, 10)
  }, [checkForClear])

  useEffect(() => {
    const inputElement = document.getElementById(inputId) as HTMLInputElement
    
    if (inputElement) {
      // Limpar interval anterior se existir
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      
      // Limpar event listener anterior se existir
      if (containerRef.current) {
        containerRef.current.removeEventListener('click', handleClick)
      }
      
      intervalRef.current = setInterval(checkForClear, 100)
      
      containerRef.current = inputElement.closest('.crx-search-container') || inputElement.parentElement
      containerRef.current?.addEventListener('click', handleClick)
      
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current)
        }
        if (containerRef.current) {
          containerRef.current.removeEventListener('click', handleClick)
        }
      }
    }
  }, [inputId, checkForClear, handleClick])
}